export default "__VITE_ASSET__e3375873__"